import { formatPhoneNumberIntl } from "../../external/react-phone-number-input/min/index.js";
const formatNumber = (value, noDashes) => {
  if (!value) return value;
  const halfFormatted = formatPhoneNumberIntl(value);
  if (!halfFormatted)
    return value;
  if (noDashes)
    return halfFormatted;
  const [code, ...theRest] = halfFormatted.split(" ");
  return `${code} ${theRest.join("-")}`;
};
export {
  formatNumber
};
//# sourceMappingURL=formatNumber.js.map
